<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{
          Object.entries(this.data).length === 0 ? "NOUVEAU" : "MODIFIER UN"
        }}
        CLIENT
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      />
    </div>
    <vs-divider class="mb-0" />
    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="px-6 py-2">
        <template v-if="logo">
          <div
            class="img-container w-64 mx-auto flex items-center justify-center"
          >
            <img :src="logo" alt="img" class="responsive" />
          </div>

          <div class="modify-img flex justify-between mt-5">
            <input
              type="file"
              class="hidden"
              ref="updateImgInput"
              @change="updateCurrImg"
              accept="image/*"
            />
            <vs-button
              class="mr-4"
              type="flat"
              @click="$refs.updateImgInput.click()"
              >Remplacer</vs-button
            >
            <vs-button
              type="flat"
              color="#999"
              @click="(logo = null), (file = null)"
              >Supprimer</vs-button
            >
          </div>
          <span style="color: red; font-size: 10px" v-if="error_data.logo">{{
            error_data.logo ? error_data.logo[0] : ""
          }}</span>
        </template>

        <vs-input
          label="Raison sociale"
          :danger="error_data.social_reason ? true : false"
          :danger-text="
            error_data.social_reason ? error_data.social_reason[0] : ''
          "
          v-model="social_reason"
          class="mt-5 w-full"
          name="item-name"
        />
        <div class="mt-5 w-full">
          <span>Commercial</span>
          <v-select
            v-model="commercial_id"
            class="w-full"
            label="name"
            placeholder="Sélectionner un commercial"
            :reduce="(user) => user.id"
            :options="commerciaux"
          ></v-select>
          <span
            style="color: red; font-size: 10px"
            v-if="error_data.commercial_id"
            >{{
              error_data.commercial_id
                ? error_data.commercial_id[0]
                : ""
            }}</span
          >
        </div>
        <div class="mt-5 w-full">
          <span>Liste des segments</span>
          <v-select
            v-model="customers_category_id"
            class="w-full"
            label="name"
            placeholder="Sélectionner un segement"
            :reduce="(user) => user.id"
            :options="segments"
          ></v-select>
          <span
            style="color: red; font-size: 10px"
            v-if="error_data.customers_category_id"
            >{{
              error_data.customers_category_id
                ? error_data.customers_category_id[0]
                : ""
            }}</span
          >
        </div>

        <div class="mt-5 w-full">
          <span class="vs-select--label">Régime de taxation</span>
          <ul class="flex mt-2">
            <li class="mr-2">
              <vs-radio
                type="radio"
                id="TTC"
                name="regime"
                v-model="tax"
                vs-value="TTC"
              />TTC
            </li>
            <li>
              <vs-radio
                type="radio"
                id="HT"
                name="regime"
                v-model="tax"
                vs-value="HT"
              />HT
            </li>
          </ul>
          <span style="color: red; font-size: 10px" v-if="error_data.tax">{{
            error_data.tax ? error_data.tax[0] : ""
          }}</span>
        </div>

        <vs-input
          label="Email"
          type="email"
          v-model="email"
          :danger="error_data.email ? true : false"
          :danger-text="error_data.email ? error_data.email[0] : ''"
          class="mt-5 w-full"
          name="item-mail"
        />

        <vs-input
          label="Téléphone"
          v-model="phone"
          :danger="error_data.phone ? true : false"
          :danger-text="error_data.phone ? error_data.phone[0] : ''"
          class="mt-5 w-full"
          name="item-phone"
        />

        <vs-input
          label="Fax"
          v-model="fax"
          :danger="error_data.fax ? true : false"
          :danger-text="error_data.fax ? error_data.fax[0] : ''"
          class="mt-5 w-full"
          name="item-fax"
        />

        <div class="mt-5">
          <vs-checkbox v-model="caution">Sous caution</vs-checkbox>
        </div>

        <vs-textarea label="Adresse" v-model="address" class="mt-5 w-full" />

        <div class="upload-img mt-5" v-if="!logo">
          <input
            type="file"
            class="hidden"
            ref="uploadImgInput"
            @change="updateCurrImg"
            accept="image/*"
          />
          <vs-button @click.prevent="$refs.uploadImgInput.click()"
            >Uploader un logo</vs-button
          >
        </div>
      </div>
    </VuePerfectScrollbar>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button @click="saveOrUpdate()" class="mr-6">Soumettre</vs-button>
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Annuler</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Datepicker from "vuejs-datepicker";
export default {
  components: { VuePerfectScrollbar, Datepicker },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
    segments: {
      type: Array,
      default: () => [],
    },
    getCustomer: {
      type: Function,
    },
    commerciaux: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      id: null,
      contractModalActive: false,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      error_data: [],
      social_reason: "",
      customers_category_id: [],
      tax: "",
      email: "",
      phone: "",
      fax: "",
      caution: "",
      address: "",
      logo: "",
      file: "",
      id_logo: "",
      user_id: "",
      commercial_id: ""
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },
  },
  methods: {
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.logo = e.target.result;
        };
        this.file = input.target.files[0];
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    initValues() {
      this.error_data = [];
      this.social_reason = "";
      this.customers_category_id = [];
      this.tax = "";
      this.email = "";
      this.phone = "";
      this.fax = "";
      this.caution = "";
      this.address = "";
      this.logo = "";
      this.file = "";
      this.id_logo = "";
      this.user_id = "";
      this.commercial_id = "";
    },
    saveOrUpdate() {
      if (this.data.id) {
        this.$vs.loading();
        let formData = new FormData();
        formData.append("id", this.id);
        formData.append("social_reason", this.social_reason);
        formData.append("customers_category_id", this.customers_category_id);
        formData.append("tax", this.tax);
        formData.append("email", this.email);
        formData.append("phone", this.phone);
        formData.append("fax", this.fax);
        formData.append("caution", this.caution);
        formData.append("address", this.address);
        formData.append("logo", this.file);
        formData.append("upload_id", this.id_logo);
        formData.append("user_id", this.user_id);
        formData.append("commercial_id", this.commercial_id);
        this.$http
          .post("customers/update", formData)
          .then((response) => {
            this.$emit("closeSidebar");
            this.$vs.loading.close();
            this.error_data = [];
            this.$vs.notify({
              title: "Modification",
              text: "Opération effectuée",
              color: "success",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.getCustomer(1);
          })
          .catch((error) => {
            if (error.response.status === 401) {
              this.$vs.notify({
                title: "Erreur",
                text: "Votre session a expiré",
                color: "danger",
                iconPack: "feather",
                icon: "icon-check",
                position: "top-right",
              });
              this.$router.push({ name: "login" });
            } else {
              this.$vs.loading.close();
              this.error_data = error.response.data.errors;
            }
          });
      } else {
        this.$vs.loading();
        let formData = new FormData();
        formData.append("social_reason", this.social_reason);
        formData.append("customers_category_id", this.customers_category_id);
        formData.append("tax", this.tax);
        formData.append("email", this.email);
        formData.append("phone", this.phone);
        formData.append("fax", this.fax);
        formData.append("caution", this.caution);
        formData.append("address", this.address);
        formData.append("logo", this.file);
        formData.append("commercial_id", this.commercial_id);
        this.$http
          .post("customers/create", formData)
          .then((response) => {
            this.$emit("closeSidebar");
            this.$vs.loading.close();
            this.error_data = [];
            this.$vs.notify({
              title: "Ajout",
              text: "Opération effectuée",
              color: "success",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.getCustomer(1);
          })
          .catch((error) => {
            if (error.response.status === 401) {
              this.$vs.notify({
                title: "Erreur",
                text: "Votre session a expiré",
                color: "danger",
                iconPack: "feather",
                icon: "icon-check",
                position: "top-right",
              });
              this.$router.push({ name: "login" });
            } else {
              this.$vs.loading.close();
              this.error_data = error.response.data.errors;
            }
          });
      }
    },
  },
  watch: {
    isSidebarActive(val) {
      this.error_data = [];
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
      } else {
        let {
          id,
          tax,
          social_reason,
          segment,
          phone,
          fax,
          email,
          address,
          caution,
          logo,
          user_id,
          commercial_id,
        } = JSON.parse(JSON.stringify(this.data));
        this.id = id;
        this.social_reason = social_reason;
        this.customers_category_id = segment.id;
        this.email = email;
        this.tax = tax;
        this.phone = phone;
        this.fax = fax ? fax : "";
        this.caution = caution;
        this.address = address ? address : "";
        this.id_logo = logo;
        this.user_id = user_id;
        this.commercial_id = commercial_id;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
